import { DateFromISO } from "sb-js-extends";
DateFromISO();
/* tslint:disable: no-non-null-assertion */
export var InitHelpers;
(function (InitHelpers) {
    function isDevEnv() {
        return process.env.NODE_ENV === "development";
    }
    InitHelpers.isDevEnv = isDevEnv;
})(InitHelpers || (InitHelpers = {}));
export var TickerHelpers;
(function (TickerHelpers) {
    TickerHelpers.UpdateStrategies = {
        init(seedValue, incrementPeriod = 1000, incrementValue = .117) {
            let generator = initUpdateStrategies(seedValue, incrementValue);
            return {
                getNextTickerValue: () => generator.next().value,
                interval: incrementPeriod
            };
        }
    };
})(TickerHelpers || (TickerHelpers = {}));
function* initUpdateStrategies(seedValue, incrementValue) {
    let val = seedValue;
    while (true) {
        yield val += incrementValue;
    }
}
export var CurrencyHelpers;
(function (CurrencyHelpers) {
    CurrencyHelpers.moneyFormat = (format, amount, currencyCode) => format.toCurrencyFormat(amount, currencyCode);
})(CurrencyHelpers || (CurrencyHelpers = {}));
export var TimeHelpers;
(function (TimeHelpers) {
    function prepareEventDateInfo(date) {
        var t = getDataTime(date).toStringEx(MonthNameDateFormat);
        return {
            dateText: t,
            adjustedDateText: this.getAdjustedDateText(date, t),
            dateDigits: getDataTime(date).toStringEx(ShortDateFormat),
            dateSuffix: date.getDateSuffix()
        };
    }
    TimeHelpers.prepareEventDateInfo = prepareEventDateInfo;
    function getAdjustedDateText(date, t) {
        var i = window.$string("General").Today || "Today", r = window.$string("General").Tomorrow || "Tomorrow";
        return date.isToday() ? i : date.isTomorrow() ? r : t;
    }
    TimeHelpers.getAdjustedDateText = getAdjustedDateText;
    function getCurrentDateTimeUTC() {
        return Date.fromISO(new Date().toISOString()).getTime();
    }
    TimeHelpers.getCurrentDateTimeUTC = getCurrentDateTimeUTC;
    function addCurrentTimeZoneHours(currentTimeZone, date) {
        let newDate = new Date(date);
        if (currentTimeZone % 1) {
            let hoursDiff = currentTimeZone - (currentTimeZone % 1);
            let minutesDiff = (currentTimeZone % 1) * 60;
            newDate.setHours(newDate.getHours() + hoursDiff, newDate.getMinutes() + minutesDiff);
        }
        else {
            newDate.setHours(newDate.getHours() + currentTimeZone);
        }
        return newDate;
    }
    TimeHelpers.addCurrentTimeZoneHours = addCurrentTimeZoneHours;
})(TimeHelpers || (TimeHelpers = {}));
//# sourceMappingURL=index.js.map